<div class="align-items-center title-purchases mobile">
    <span (click)="backTab()"><i class="icon-back fa-light fa-arrow-left"></i></span>
    <p class="name-profile m-0" (click)="backTab()">Atrás</p>
</div>
<div class="menu-payment-methods">
    <div class="section">
        <div >
            <h2 class="title">Métodos de pago</h2>
            <p class="subtitle">Métodos de pago guardados</p>
        </div>
        <div *ngIf="userCards.length === 0">
            <p class="no-cards">No tienes tarjetas guardadas</p>
        </div>
        <div class="card" *ngFor="let card of userCards">
            <i class="fa-brands fa-cc-visa card-icon"></i>
            <p>Tarjeta terminada en *{{card.last4}}</p>
            <i class="fa-regular fa-trash delete-icon" (click)="deleteCard(card)"></i>
        </div>
    </div>
</div>
